<template>
  <div v-if="report.companyoverview.creditreport">
    <report-panel :report="report" :anchor="''">
      <div slot="title">Credit Commentary</div>
      <div slot="body">
        <table class="table table-striped" id="credit-commentary-table">
          <thead>
            <tr>
              <th>Direction</th>
              <th>Comment</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="comment in report.companyoverview.creditreport.creditcommentaries"
              :key="comment.id"
            >
              <td>
                <span v-bind:class="'label label-' + comment.direction.toLowerCase()">
                  {{ comment.direction }}
                </span>
              </td>
              <td>
                {{ comment.comment }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </report-panel>
  </div>
</template>

<script>
import toolsMixin from '@/components/reports/ToolsMixin';
import ReportPanel from '@/components/reports/components/ReportPanel';

export default {
  components: {
    ReportPanel,
  },
  mixins: [toolsMixin],
  props: ['report'],
};
</script>
